<template lang="pug">
	.upload-button
		.icon(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Publish creative'}" v-pseudo-modal-show="'upload-dropdown'")
			.fa.fa-upload
		.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'upload-dropdown'")
			.dropdown-header(class="text-center")
				strong Publish creative
			.networks(v-bar)
				.networks-content
					.dropdown-item.amazon(@click="uploadCreative('amazon')" v-if="Publisher.SelectedPublisher.options['AmazonS3']")
						.item-title Amazon S3
						.item-icon(v-bind:style="{backgroundImage: 'url(/Images/Icons/Services/amazon.png)', width: '46px'}")
						.item-description.text-muted Upload to Amazon S3 bucket
					.dropdown-item.sky-kids(@click="uploadCreative('sky-kids')" v-if="Publisher.SelectedPublisher.options['SkyKids']")
						.item-title Sky Kids
						.item-icon(v-bind:style="{backgroundImage: 'url(/Images/Icons/Networks/sky-kids.png)', opacity: 1}")
						.item-description.text-muted Upload to Sky Kids FTP
					.dropdown-item.mraidio(@click="uploadCreative('mraidio')")
						.item-title {{SetupSettings.domain}}
						.item-icon(v-bind:style="{backgroundImage: 'url(/Images/Icons/Services/mraidio.png)', width: '46px'}")
						.item-description.text-muted {{`Upload to ${SetupSettings.domain} server`}}
</template>

<script>

	import Screen from './../../mixins/screen';

	import { Publisher } from '../../services/Publisher'
	import { Creative } from '../../services/Creative'
	import SetupSettings from "./../../settings/settings";

	export default {
		name: "UploadButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched"]
		},
		data() {

			this.Publisher = Publisher;
			this.Creative = Creative;
			this.SetupSettings = SetupSettings;

			return {
				showed: true
			};

		},
		methods: {
			uploadCreative(type) {

				if (type === 'amazon') {

					Broadcast.call("Show UploadAmazonS3");

				} else if (type === 'sky-kids') {

					Broadcast.call("Show UploadSkyKids");

				} else if (type === 'mraidio') {

					Broadcast.call("Show UploadMraidio");

				}

				Broadcast.call("Pseudo Modal Hide", ['upload-dropdown']);

			}
		}
	}
</script>


<style lang="sass">

	.upload-button
		list-style: none
		position: relative

		.dropdown-menu
			position: absolute
			left: -230px
			top: 40px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 300px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default

			.networks
				height: auto
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 300px

				.item-title
					margin-bottom: 5px
					padding-top: 5px

				.item-description
					white-space: normal
					line-height: 12px
					font-size: 0.6rem
					width: 66%

				.item-icon
					position: absolute
					bottom: 5px
					right: 10px
					width: calc(37% - 10px)
					height: 44px
					opacity: 1
					background-size: contain
					background-repeat: no-repeat
					background-position: right center
					max-height: 55px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

</style>

